import DataManagement from './DataManagement';

export default DataManagement;
